/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable functional/no-conditional-statement */
import { FC } from "react";
import { useTitle } from "../hooks/useTitle";

export const LoginRedirection: FC = () => {
  useTitle();
  return  (
    <div className="tw-p-8">
      <div className="tw-flex  tw-justify-center tw-items-center tw-gap-6">
        <div className="tw-font-bold">
          <div className="tw-text-2xl">Please wait while we sign you in</div>
        </div>
      </div>
    </div>
  );
};
